import { createContext } from "react";

const userData = JSON.parse(localStorage.getItem('userData')) || null;
export const UserDataContext = createContext(userData);